export async function callOpenAI(input: string, context: any, apiKey: string, signal?: AbortSignal): Promise<string> {
  try {
    const res = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json'
      },
      signal,
      body: JSON.stringify({
        model: context.modelOverride || 'gpt-4o-mini',
        messages: [
          { 
            role: 'system', 
            content: context.systemPrompt || `You are OS Bot, a real estate CRM assistant. Personality: ${context.personality || 'professional'}.` 
          },
          ...(context.messages || []).map((m: any) => ({
            role: m.role === 'ai' ? 'assistant' : m.role,
            content: m.content
          })),
          { role: 'user', content: input }
        ],
        temperature: 0.2,
        max_tokens: 512
      })
    });
    
    if (!res.ok) {
      const errorBody = await res.text();
      console.error(`[OpenAI Provider] HTTP Error ${res.status}:`, errorBody);
      try {
        const errorData = JSON.parse(errorBody);
        throw new Error(errorData.error?.message || `OpenAI API Error: ${res.status}`);
      } catch (e) {
        throw new Error(`OpenAI API Error: ${res.status}`);
      }
    }

    const data = await res.json();
    return data.choices?.[0]?.message?.content || '';
  } catch (error: any) {
    console.error('[OpenAI Provider] Fetch Error:', error);
    throw error;
  }
}
